import React from 'react';
import { Props } from './UWSection.types';
import styles from './UWSection.module.scss';

const UWSection: React.FC<Props> = ({ children, title }) => {
  return (
    <div>
      <div className={styles.title}>
        <h3>{title}</h3>
      </div>
      <div className={styles.section}>{children}</div>
    </div>
  );
};

export default UWSection;
